import { useQuery } from '@tanstack/react-query'
import { getPopularVerticals } from '@pepper/utils/src/api/analytics/anayltics'

type ReturnType = {
  isError: boolean
  data: VerticalID[]
  refetch: () => void
  isLoading: boolean
}

export const usePopularVerticals = (index: string): ReturnType => {
  const handleApiRequest = async () => {
    const { status, data, error } = await getPopularVerticals()

    if (status === 'ok' && data) {
      return data.response || data
    } else {
      throw new Error(error)
    }
  }

  const { isError, isLoading, data, refetch } = useQuery<VerticalID[], Error>(
    [index],
    handleApiRequest
  )

  return {
    isError,
    isLoading,
    data: data ?? [],
    refetch
  }
}
